import { remoteParticipantsPath } from 'app/constants';
import { QueryKeys, useDeleteRemoteParticipant } from 'data';
import DeleteModal, { IDeleteModalProps } from '../delete-modal';

export const RemoteParticipantDeleteModal = ({ entityName, onClose, onSettled }: IDeleteModalProps) => {
  const { mutate: deleteRemoteParticipant, isLoading: isParticipantDeleting } = useDeleteRemoteParticipant();

  return (
    <DeleteModal
      title="Remove remote participant?"
      modalText={`Are you sure you want to remove ${entityName} ?`}
      entityName={entityName}
      successMessage={
        <div>
          Remote participant <strong>{entityName}</strong> was removed
        </div>
      }
      redirectPath={remoteParticipantsPath}
      queryKey={QueryKeys.REMOTE_PARTICIPANTS}
      deleteMethod={deleteRemoteParticipant}
      onClose={onClose}
      onSettled={onSettled}
      isLoading={isParticipantDeleting}
    />
  );
};
